/* ===== CAROUSEL.JS — Lightweight Slideshow ===== */

(function() {
  'use strict';

  var carousel = document.querySelector('[data-carousel]');
  if (!carousel) return;

  var slides = carousel.querySelectorAll('.hero-carousel__slide');
  var dots = carousel.querySelectorAll('.hero-carousel__dot');
  var prevBtn = carousel.querySelector('[data-carousel-prev]');
  var nextBtn = carousel.querySelector('[data-carousel-next]');

  if (slides.length <= 1) return;

  var current = 0;
  var total = slides.length;
  var autoplayInterval = null;
  var section = carousel.closest('.hero-section');
  var autoplay = true;
  var speed = 5000;

  function goTo(index) {
    slides[current].classList.remove('active');
    if (dots[current]) dots[current].classList.remove('active');

    current = (index + total) % total;

    slides[current].classList.add('active');
    if (dots[current]) dots[current].classList.add('active');
  }

  function next() {
    goTo(current + 1);
  }

  function prev() {
    goTo(current - 1);
  }

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    autoplayInterval = setInterval(next, speed);
  }

  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Navigation
  if (nextBtn) nextBtn.addEventListener('click', function() { next(); startAutoplay(); });
  if (prevBtn) prevBtn.addEventListener('click', function() { prev(); startAutoplay(); });

  // Dots
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      goTo(i);
      startAutoplay();
    });
  });

  // Touch support
  var touchStartX = 0;
  var touchEndX = 0;

  carousel.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
    stopAutoplay();
  }, { passive: true });

  carousel.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    var diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();
      else prev();
    }
    startAutoplay();
  }, { passive: true });

  // Pause on hover
  carousel.addEventListener('mouseenter', stopAutoplay);
  carousel.addEventListener('mouseleave', startAutoplay);

  // Start
  startAutoplay();

})();
